import { isApiError } from "@sagot/api-client";
import { consoleRoutes } from "@sagot/constants";
import { useTranslation } from "@sagot/i18n";
import { AppLink, Button, Icon } from "@sagot/ui";
import { useWorkspaceContext } from "../../../session/workspace-context";

/** True for a plan-gate response (HTTP 402 from the API). */
export function isPlanGated(error: unknown): boolean {
  return isApiError(error) && error.isPlanGate;
}

/** Upgrade card rendered in place of a feature the workspace plan doesn't include. */
export function UpgradeCard({ feature, minPlan }: { feature: string; minPlan?: string }) {
  const { t } = useTranslation();
  const { summary } = useWorkspaceContext();
  return (
    <section className="card card-body flex flex-col gap-4 md:flex-row md:items-center" aria-labelledby="engage-upgrade-title" data-testid="plan-gate">
      <span className="inline-flex size-12 shrink-0 items-center justify-center rounded-lg bg-primary-soft text-primary-ink">
        <Icon name="lock" className="size-6" />
      </span>
      <div className="min-w-0 flex-1">
        <h2 id="engage-upgrade-title" className="text-base font-bold">
          {t("engage.planGate.title", { feature })}
        </h2>
        <p className="mt-1 text-sm text-fg-muted">{minPlan ? t("engage.planGate.bodyPlan", { feature, plan: minPlan }) : t("engage.planGate.body")}</p>
      </div>
      <Button asChild>
        <AppLink href={consoleRoutes.billing(summary.slug)}>
          <Icon name="arrow-up-right" />
          {t("engage.planGate.upgrade")}
        </AppLink>
      </Button>
    </section>
  );
}
